<template>
    <div>
        <b-button
            v-if="params.data.component != 'verification'"
            class="align-baseline mr-1"
            title="Edit"
            variant="default"
            @click="showEditModal"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            v-if="params.data.component != 'verification'"
            class="align-baseline"
            title="Delete"
            variant="default"
            @click="showDeleteModal"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalId"
            title="Delete Module"
            ok-title="Confirm"
            @ok.prevent="deleteModule"
        >
            Are you sure you want to delete module {{ params.data.name }}?
        </modal>
        <create-edit-module-modal
            :modalId="editModalId"
            :packageData="packageData"
            modalTitle="Edit Module"
            @submit="updateModule"
        ></create-edit-module-modal>
    </div>
</template>
<script>
import API from '../../api';
import FormInput from '../generic/form-input/form-input.vue';
import FormSelect from '../generic/form-select/form-select.vue';
import FormTextarea from '../generic/form-textarea/form-textarea.vue';
import modal from '../generic/modal/modal.vue';
import CreateEditModuleModal from './create-edit-module-modal.vue';
import { PACKAGES_LIST_ENDPOINT } from '../../endpoints';

export default {
    components: {
        modal,
        CreateEditModuleModal,
    },
    computed: {
        editModalId() {
            return 'edit-modal' + this.params.data.id;
        },
        deleteModalId() {
            return 'delete-modal' + this.params.data.id;
        },
        packageData() {
            const {
                name,
                description,
                amount,
                status,
                component,
            } = this.params.data;
            return {
                name,
                package_id: this.params.data.package?.id || null,
                description,
                status,
                amount,
                component,
            };
        },
    },
    methods: {
        async showEditModal() {
            this.$bvModal.show(this.editModalId);
        },
        showDeleteModal() {
            this.$bvModal.show(this.deleteModalId);
        },
        updateModule(value) {
            this.params.updateModule &&
                this.params.updateModule(
                    this.params.data.id,
                    value,
                    this.editModalId
                );
        },
        deleteModule() {
            this.params.deleteModule &&
                this.params.deleteModule(
                    this.params.data.id,
                    this.deleteModalId
                );
        },
    },
};
</script>